<template>
  <div>
    <doughnut-chart
      v-if="dataCollection"
      :data="dataCollection"
      :options="options"
      :height="height"
    ></doughnut-chart>
  </div>
</template>

<script>
import DoughnutChart from "../common/DoughnutChart.js";

export default {
  components: {
    DoughnutChart
  },
  props: {
    height: {
      type: Number,
      default: 200
    },
    graphData: {
      type: Array,
      default: [
        { name: "Перешли по ссылке", value: 0 },
        { name: "Закрыли рекламу", value: 0 }
      ]
    }
  },
  data: () => ({
    emptydataCollection: {
      datasets: [
        {
          borderWidth: 0,
          backgroundColor: ["#D8EDFF"],
          data: [1]
        }
      ],
      labels: ["Нет данных"]
    },
    emptydataOptions: {
      cutoutPercentage: 35,
      tooltips: { enabled: false },
      hover: { mode: null },
      legend: {
        display: false
      }
    },
    dataCollection: {},
    options: {
      cutoutPercentage: 35,
      legend: {
        display: false
      }
    }
  }),
  mounted() {
    setTimeout(() => {
      if (this.graphData[0].value !== 0 || this.graphData[1].value !== 0) {
        this.dataCollection = {
          datasets: [
            {
              borderWidth: 0,
              backgroundColor: ["#92CC6D", "#FF5A45"],
              data: [this.graphData[0].value, this.graphData[1].value]
            }
          ],
          labels: [this.graphData[0].name, this.graphData[1].name]
        };
      } else {
        this.dataCollection = this.emptydataCollection;
        this.options = this.emptydataOptions;
      }
    }, 1000);
  },
  methods: {}
};
</script>
